export const STAGES = {
  CREATION: "creation",
  CUTTING: "cutting",
  SAMPLING_DIGITIZER: "sampling_digitizer",
  SECONDARY_PROCESS: "secendory_process",
  EMBROIDARY: "embroidary",
  PRODUCTION: "production",
  PACKING: "packing",
  ACCOUNT: "account",
  PAYMENT: "payment",
  DISPATCH: "dispatch",
  COMPLETED: "completed",
};
export const ROLES = {
  ADMIN: "admin",
  DESIGN: "designer",
  CUTTING: "cutting",
  SAMPLING_DIGITIZER: "sampling_digitizer",
  SECONDARY_PROCESS: "secendory_process",
  EMBROIDARY: "embroidary",
  PRODUCTION: "production",
  PACKING: "packing",
  ACCOUNT: "accountent",
  PAYMENT: "payment",
  DISPATCH: "dispatch",
  VIEWER: "viewer",
};

export const STAGES_LIST = Object.keys(STAGES).map((key) => STAGES[key]);

// edit -> admin, design
// view without client details -> cutting, production, account
